// import moment from 'moment';



export const getNonOptimalShipmentsData = async () => {


    let firstTry = await APICall(10000)
    // console.log('getNonOptimalShipmentsData first', firstTry)
    if (typeof firstTry === "object") {
        return firstTry
    } else {
        let secondTry = await APICall(10000)
        // console.log('getNonOptimalShipmentsData second', secondTry)
        if (typeof secondTry === "object") {
            return secondTry
        } else {
            let thridTry = await APICall(10000)
            // console.log('getNonOptimalShipmentsData third', thridTry)
            if (typeof thirdTry === "object") {
                return thridTry
            } else {
                console.warn("getNonOptimalShipmentsData saw an api call fail 3x")
                return 'failed'
            }
        }
    }

    async function APICall(timeOutValue) {

        return new Promise(function (resolve, reject) {

            let controller = new AbortController();

            let url = "https://api.shippersedge.com/analyze/client/kissner/optimal-by-week"

            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");

            var requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            let request = new Request(url, requestOptions);

            if (timeOutValue) {
                setTimeout(() => controller.abort(), timeOutValue);
            }


            fetch(request)
                .then((response) => {
                    // console.log(
                    //   "debug getNonOptimalShipmentsData.js response",
                    //   response
                    // );
                    if (!response.ok) {
                        console.error(
                            "getNonOptimalShipmentsData.js error",
                            response.statusText,
                            response
                        );
                        throw Error(response.statusText);
                    }
                    return response.json();
                })
                .then((response) => {
                    // console.log('getNonOptimalShipmentsData', response)
                    resolve(response);
                })
                .catch((err) => {
                    console.error("getNonOptimalShipmentsData API Request failed", err);
                    resolve(err);
                });
        });
    }
};

export default getNonOptimalShipmentsData